import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  active: boolean;
  href?: string;
  icon?: React.ReactNode;
  content?: React.ReactNode;
  title?: string;
  children?: React.ReactNode;
  collapsed: boolean;
};

export default function NavigationItem({
  className,
  style,
  active,
  href,
  icon,
  content,
  title,
  children = content,
  collapsed,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Link
        title={title}
        className={cx(styles.item, active ? styles.itemActive : undefined)}
        href={href || "#disabled"}
      >
        <Flex.Row
          padding="12px 24px"
          alignItems="center"
          gap="12px"
          justifyContent="space-around"
        >
          {icon ? (
            <Flex.Row className={styles.fontSize24}>{icon}</Flex.Row>
          ) : undefined}
          <Flex.Cell
            className={cx(
              styles.lineHeight125,
              collapsed ? styles.hidden : undefined
            )}
            flex="1 1 auto"
          >
            {children}
          </Flex.Cell>
        </Flex.Row>
      </Link>
    </div>
  );
}
